export default __webpack_public_path__ + "static/media/IMG_0465 copie.bd707330.jpg";